(function(){
    'use strict';

    angular.module('dataHandlingModule', [
        'ngAnimate',
        'journey.canvas.srv',
        'dataHandlingActionAddList',
        'dataHandlingIsNotInSegment',
        'dataHandlingIsInSegment',
        'dataHandlingActionAddWaitTime',
        'dataHandlingActionUpdateField',
        'dataHandlingActionRemoveList',
        'dataHandlingConditionIsInList',
        'dataHandlingConditionWebsiteActivity',
        'dataHandlingConditionIfElse',
        'dataHandlingConditionEmailEngagement',
        'dataHandlingActionSendEmail',
        'dataHandlingActionFacebookAudience'
    ])
        .controller('dataHandleCtrl', ['$scope', '$rootScope', '$location', '$timeout', '$stateParams', 'canvasService', 'helpers', dataController]);

    function dataController($scope, $rootScope){
        $rootScope.$watch('translate', function(func) {
            if(func) {
                $scope.translate = func;
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        });
    }

})();



// WEBPACK FOOTER //
// ./app/controllers/dataHandlingController.js